'use strict';
module.exports = function LoginHintAuthenticator(authenticator, getLoginHint) {
	const self = this;
	self.modalAuthenticate = function () {
		return authenticator.modalAuthenticate(getLoginHint());
	};
	self.backgroundAuthenticate = function () {
		return authenticator.backgroundAuthenticate(getLoginHint());
	};
};
